import React, { useState } from 'react'
import { usePlayerStore } from '../store/player-store'
import { useUIStore } from '../store/ui-store'

export default function LoginScreen(): React.ReactElement {
  const { token, loginGuest, isLoading } = usePlayerStore()
  const { navigateTo } = useUIStore()
  const [localError, setLocalError] = useState('')

  React.useEffect(() => {
    if (token) navigateTo('lobby')
  }, [token])

  const handleGuestPlay = async (): Promise<void> => {
    setLocalError('')
    await loginGuest()
    if (!token) setLocalError('Failed to create guest account')
  }

  const handleOAuth = async (provider: 'google' | 'facebook' | 'line'): Promise<void> => {
    setLocalError('')
    const mockToken = provider + '_' + crypto.randomUUID()
    try {
      const { loginOAuth } = usePlayerStore.getState()
      await loginOAuth(provider, mockToken)
      navigateTo('lobby')
    } catch {
      setLocalError('OAuth login failed')
    }
  }

  return (
    <div className="flex-center" style={{ flex: 1, flexDirection: 'column', gap: 24, padding: 32 }}>
      <div style={{ fontSize: 64, marginBottom: 8 }}>♠</div>
      <div style={{ color: '#f5c518', fontSize: 28, fontWeight: 800, letterSpacing: 2 }}>
        POKER CLUB
      </div>
      <div style={{ color: '#888', fontSize: 14, textAlign: 'center', maxWidth: 300 }}>
        Free Texas Hold'em — Play with friends and players worldwide
      </div>

      {localError && (
        <div style={{ color: '#d32f2f', fontSize: 12, textAlign: 'center', background: 'rgba(211,47,47,0.1)', padding: '8px 16px', borderRadius: 8 }}>
          {localError}
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%', maxWidth: 280 }}>
        <button className="btn btn-primary" disabled={isLoading} style={{ padding: '14px 0', fontSize: 16, fontWeight: 600 }} onClick={handleGuestPlay}>
          {isLoading ? 'Connecting...' : 'Play as Guest'}
        </button>
      </div>

      <div style={{ width: '100%', maxWidth: 280, display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.1)' }} />
        <span style={{ color: '#666', fontSize: 12 }}>or</span>
        <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.1)' }} />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%', maxWidth: 280 }}>
        <button className="btn btn-secondary" style={{ padding: '12px 0', fontSize: 14 }} onClick={() => handleOAuth('google')}>
          Continue with Google
        </button>
        <button className="btn btn-secondary" style={{ padding: '12px 0', fontSize: 14 }} onClick={() => handleOAuth('facebook')}>
          Continue with Facebook
        </button>
        <button className="btn btn-secondary" style={{ padding: '12px 0', fontSize: 14 }} onClick={() => handleOAuth('line')}>
          Continue with LINE
        </button>
        <div style={{ fontSize: 11, color: '#555', textAlign: 'center', marginTop: 4 }}>
          OAuth login creates an account linked to your social profile
        </div>
      </div>

      <div style={{ marginTop: 24, fontSize: 11, color: '#555', textAlign: 'center', lineHeight: 1.6 }}>
        This is a social casino game. Chips have no real-world value.<br />
        Must be 18+ to play.
      </div>
    </div>
  )
}
